// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>22</span>&nbsp;&nbsp;Turn from me shame and rebuke,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for I have kept your testimonies.<br> </p> </div></div>";
// Exports
module.exports = code;